// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1lhr_","actionsCol":"EnrolledClinics_actionsCol__3llmD"};